module.exports = __webpack_public_path__ + "img/avatar0.4d19654e.png";